import { MainLayout } from "~/components";
import { useEffect, forwardRef, useRef, Ref } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { HeroPage } from "./HeroPage";
import { height } from "@mui/system";
import { bullet } from "~/assets";
import Typography from "@mui/material/Typography";
import Box from "@material-ui/core/Box";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { IconButton, Hidden } from "@mui/material";
import { RoadCard } from "~/components";
import R1 from "../../assets/svgs/R1.png";
import R2 from "../../assets/svgs/R2.png";
import R3 from "../../assets/svgs/R3.png";

export const Roadmap = () => {
  const data = [
    {
      q: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.295rem", opacity: "0.5", fontSize: "18px" }}
          >
            Q1 2022
          </Typography>
        </Box>
      ),
      subtitle: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: '#fff'}}
            fontSize={{
              lg:'28px',
              xs: '20px'
            }}
            variant="body1"
          >
            Concept Phase
          </Typography>
        </Box>
      ),
      para: (
        <Box textAlign={'center'}>
          <Box
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Box display="flex" alignItems={'center'}>
              <img src={bullet} alt="icon" height={20} width={20} />
            </Box>
            <Box>
              <Typography
                textAlign={'start'}
                // variant="body2"
                ml={2}
                variant="body2"
              >
                Participation in Acceleration Programme
              </Typography>
            </Box>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Box>
              <img src={bullet} alt="icon" height={20} />
            </Box>
            <Box>
              <Typography textAlign={'start'} variant="body2" ml={2}>
                Development of project concept
              </Typography>
            </Box>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Core Team formation
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Market research
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography variant="body2" ml={2}>
              Establishing Plan for 2022
            </Typography>
          </Box>
        </Box>
      ),
      background: R1,
    },
    {
      q: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.295rem", opacity: "0.5", fontSize: "18px" }}
          >
            Q2 2022
          </Typography>
        </Box>
      ),
      subtitle: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: '#fff' }}
            fontSize={{
              lg:'28px',
              xs: '20px'
            }}
            variant="body1"
          >
            Platform Launch Phase
          </Typography>
        </Box>
      ),
      para: (
        <Box>
          <Box
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Website V1 launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Whitepaper launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <img src={bullet} alt="icon" style={{height:'fit-content', marginTop:5}} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Formulating business model and tokenomics
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              SkillSearch beta launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Community build-up{' '}
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Discord launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Seed round
            </Typography>
          </Box>
        </Box>
      ),
      background: R2,
    },
    {
      q: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.295rem", opacity: "0.5", fontSize: "18px" }}
          >
            Q3 2022
          </Typography>
        </Box>
      ),
      subtitle: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: '#fff'}}
            fontSize={{
              lg:'28px',
              xs: '20px'
            }}
            variant="body1"
          >
            Development Phase
          </Typography>
        </Box>
      ),
      para: (
        <Box>
          <Box
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <Box mt={1}>
              <img src={bullet} alt="icon" style={{height:'fit-content'}} />
            </Box>
            <Box>
              <Typography
                // textAlign={"center"}
                variant="body2"
                ml={2}
              >
                Creation of SKILLS token and smart contract
              </Typography>
            </Box>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Token Panel launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Private Sale
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Smart Contract Audit
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              SkillSearch 1.0 launch 
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Mentoring programme launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Strategic Partnerships
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <Box mt={1}>
              <img src={bullet} alt="icon" style={{height:'fit-content'}} />
            </Box>
            <Typography
              // textAlign={"center"}
              variant="body2"
              ml={2}
            >
              Mass marketing campaign (eg. engaging influencers)
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Whitelist registration
            </Typography>
          </Box>
        </Box>
      ),
      background: R3,
    },
    {
      q: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.295rem", opacity: "0.5", fontSize: "18px" }}
          >
            Q4 2022
          </Typography>
        </Box>
      ),
      subtitle: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: '#fff'}}
            fontSize={{
              lg:'28px',
              xs: '20px'
            }}
            variant="body1"
          >
            TGE Phase
          </Typography>
        </Box>
      ),
      para: (
        <Box>
          <Box
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <img src={bullet} alt="icon" style={{height:'fit-content', marginTop:5}} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Decentralised Learning Academy MVP launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
              Task-bounties model launch 
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            
          >
            <img src={bullet} alt="icon" style={{height:'fit-content', marginTop:5}} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Skillsbite NFT collection with exclusive presale
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems='center'
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Public Sale
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            DEX listing
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            CoinmarketCap and Coingecko listing
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Staking Stage V1
            </Typography>
          </Box>
        </Box>
      ),
      background: R1,
    },
    {
      q: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.295rem", opacity: "0.5", fontSize: "18px" }}
          >
            Q1 2023
          </Typography>
        </Box>
      ),
      subtitle: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: '#fff'}}
            fontSize={{
              lg:'28px',
              xs: '20px'
            }}
            variant="body1"
          >
            DLA Ecosystem
          </Typography>
        </Box>
      ),
      para: (
        <Box>
          <Box
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <img src={bullet} alt="icon" style={{height:'fit-content', marginTop:5}} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Skillsbite’s first crypto and blockchain courses
            </Typography>
          </Box>
          <Box
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <img src={bullet} alt="icon" style={{height:'fit-content', marginTop:5}} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Website 2.0 launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Development of community incentives
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Staking Stage V2
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Rewards system launch
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Learn2Earn model V1
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Regular burning and buyback
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Strategic Partnerships
            </Typography>
          </Box>
        </Box>
      ),
      background: R2,
    },
    {
      q: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.295rem", opacity: "0.5", fontSize: "18px" }}
          >
            Q2 2023
          </Typography>
        </Box>
      ),
      subtitle: (
        <Box>
          <Typography
            textAlign={'center'}
            sx={{ color: '#fff'}}
            fontSize={{
              lg:'28px',
              xs: '20px'
            }}
            variant="body1"
          >
            DLA further expansion
          </Typography>
        </Box>
      ),
      para: (
        <Box textAlign={'center'}>
          <Box
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Box display="flex" alignItems={'center'}>
              <img src={bullet} alt="icon" height={20} width={20} />
            </Box>
            <Box>
              <Typography
                textAlign={'start'}
                // variant="body2"
                ml={2}
                variant="body2"
              >
                Skillsbite Recommendation System
              </Typography>
            </Box>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Box>
              <img src={bullet} alt="icon" height={20} />
            </Box>
            <Box>
              <Typography textAlign={'start'} variant="body2" ml={2}>
              SkillSearch 2.0 launch
              </Typography>
            </Box>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Box>
              <img src={bullet} alt="icon" height={20} />
            </Box>
            <Box>
              <Typography textAlign={'start'} variant="body2" ml={2}>
              NFT marketplace launch
              </Typography>
            </Box>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            CEX listing
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <img src={bullet} alt="icon" height={20} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Learn2Earn model V2
            </Typography>
          </Box>
          <Box
            paddingTop={'5px'}
            display={'flex'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <img src={bullet} alt="icon" style={{height:'fit-content', marginTop:5}} />
            <Typography textAlign={'start'} variant="body2" ml={2}>
            Beginning of work on educational metaverse
            </Typography>
          </Box>
        </Box>
      ),
      background: R3,
    },
  ];





  /////////////////////////////////////////////////////////////////////////////////////////////





  const ref = useRef(null)
  const scroll = (scrollOffset: number) => {
    // @ts-ignore: Object is possibly 'null'.
    ref.current.scrollLeft += scrollOffset;
    console.log('scrolling')
  };

  const useStyles = makeStyles((theme) => ({
    container:{
      justifyContent: 'flex-start',
      display:"flex",
      flexDirection:"row",
      overflowX:"scroll",
      scrollBehavior: "smooth",
      [theme.breakpoints.up('lg')]:{overflowX:"hidden"}
    },
    desktop:{
      display:'none',
      [theme.breakpoints.up('lg')]:{
        display: 'flex'
      },
    },
  
    mobile: {
      display:'flex',
      [theme.breakpoints.up('lg')]:{
        display: 'none'
      },
    }
  }));

  const classes= useStyles()
  return (
    <Box display="flex" maxWidth='1440px' width={{xs:'90%', xl:'100%'}} flexDirection="column" marginTop={10} 
     id="roadmap">
      <Box
        display={'flex'}
        flexDirection={{ xs: 'column', lg: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        
      >
        <Box mb={5}>
          <Typography textAlign={{xs:"center",lg:"start"}} 
          variant="h5"
          style={{
            backgroundColor:"#F69501",
            backgroundImage: 'linear-gradient(268.99deg, #F69501 0.03%, #F1756E 100.53%)',
            WebkitTextFillColor:'transparent',
            backgroundClip:'text',
            WebkitBackgroundClip:'text'
          }}
          fontSize={{xs:'12px', md:'16px'}}
          lineHeight={{xs:'18px', md:'26px'}}
          letterSpacing='0.2rem'
          >
            ROADMAP
          </Typography>
          <Typography mt={2} fontSize={{xs:'24px', lg:'40px'}} textAlign={{xs:"center",lg:"start"}} variant="h6">
            The Road to knowledge
          </Typography>
        </Box>

        <Hidden mdDown>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className={classes.desktop}
            // marginRight={10}
          >
            <IconButton
              sx={{
                color: '#fff',
                // marginLeft: "700px",
                marginTop: '10px',
              }}
            >
              <ArrowBackIosIcon onClick={() => scroll(-250)} fontSize="large" />
              <ArrowForwardIosIcon onClick={() => scroll(250)} fontSize="large" />
            </IconButton>
          </Box>
        </Hidden>
      </Box>

    <div style={{ overflowX:"hidden",}}>
      
      <div
        className={classes.container}
        // display="flex"
        // overflow={{ xs:"scroll"}}
        
        
        // flexDirection="row"
        // justifyContent={{ xs: "flex-start", lg: "space-between" }}
        
        ref={ref}
      >
        {data.map((item, index) => {
          return (
            <RoadCard
              q={item.q}
              title={item.subtitle}
              para={item.para}
              background={item.background}
            />
          );
        })}
      </div>
      
    </div>

        
          <Box
            justifyContent="center"
            alignItems="center"
            className={classes.mobile}
            mt={2}
            // marginRight={10}
          >
            <IconButton
              sx={{
                color: '#fff',
                // marginLeft: "700px",
                marginTop: '10px',
              }}
            >
              <ArrowBackIosIcon onClick={() => scroll(-250)} fontSize="large" />
              <ArrowForwardIosIcon onClick={() => scroll(250)} fontSize="large" />
            </IconButton>
          </Box>
        

    </Box>
  );
};
